














































































































































































































































import LatestEntriesCardEmpty from "@/components/cards/LatestEntriesCardEmpty.vue";
import CompanySideCard from "@/components/company/CompanySideCard.vue";
import SharedContentSideCard from "@/components/partner/SharedContentSideCard.vue";
import PersonSideCard from "@/components/person/PersonSideCard.vue";
import RepairEstimatePartyForm from "@/components/repair-estimate/RepairEstimatePartyForm.vue";
import SharedContentList from "@/components/shared-content/SharedContentList.vue";
import TemplateDialog from "@/components/template/TemplateDialog.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import CopyClipboardText from "@/components/utility/CopyClipboardText.vue";
import Debug from "@/components/utility/Debug.vue";
import MActionList from "@/components/utility/mmmint/MActionList.vue";
import MDetailTable, {
  DetailTableTypeEnum,
  DetailTableVisualizationEnum,
  IMDetailTableConfig
} from "@/components/utility/mmmint/MDetailTable.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction, IAlert, IChips } from "@/components/utility/mmmint/MHeader.vue";
import RefsInvoiceParty from "@/components/utility/RefsInvoiceParty.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import SelectEntity from "@/components/utility/SelectEntity.vue";
import { getFlagEmoji, getFlagEmojiByLanguage } from "@/lib/CountryCodeHelper";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { emailRule, phoneRuleOptional } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { ClearanceApprovalGoToHelper } from "@/lib/utility/clearance-approval.go-to-helper";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { RepairEstimateGoToHelper } from "@/lib/utility/repair-estimate.go-to-helper";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Address } from "@/models/address.entity";
import { ClearanceApproval, IClearanceApproval } from "@/models/clearance-approval.entity";
import { Company, ICompany } from "@/models/company.entity";
import { IPerson, Person } from "@/models/person.entity";
import { IReference } from "@/models/reference.entity";
import { IRepairEstimate, RepairEstimate } from "@/models/repair-estimate.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { ISignDocument, SignDocument } from "@/models/sign-document.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { RepairEstimateDataAccessLayer } from "@/store/modules/access-layers/repair-estimate.access-layer";
import { DocumentModule } from "@/store/modules/document.store";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { RefsMessagesModule, RefTypeMap } from "@/store/modules/refs.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import RefsSelected from "../utility/RefsSelected.vue";
import RefsVehicle from "../utility/RefsVehicle.vue";
import ClearanceApprovalChangeExpirationDialog from "./ClearanceApprovalChangeExpirationDialog.vue";
import ClearanceApprovalCreateClearanceDialog from "./ClearanceApprovalCreateClearanceDialog.vue";
import ClearanceApprovalCreateRequestDialog from "./ClearanceApprovalCreateRequestDialog.vue";
import ClearanceApprovalDetailAddResponse from "./ClearanceApprovalDetailAddResponse.vue";
import ClearanceApprovalDetailForm from "./ClearanceApprovalDetailForm.vue";

@Component({
  components: {
    MHeader,
    MDetailViewGrid,
    MDetailTable,
    ActivityCard: () => import("@/components/thg/ActivityCard.vue"),
    MActionList,
    ConfirmActionDialog,
    Debug,
    CopyClipboardText,
    RefsSelect,
    SharedContentSideCard,
    LatestEntriesCardEmpty,
    ClearanceApprovalCreateRequestDialog,
    ClearanceApprovalCreateClearanceDialog,
    RefsInvoiceParty,
    ClearanceApprovalChangeExpirationDialog,
    TemplateDialog,
    RepairEstimatePartyForm,
    PersonSideCard,
    CompanySideCard,
    ClearanceApprovalDetailForm,
    ClearanceApprovalDetailAddResponse,
    SelectAssignees,
    RefsSelected,
    SelectEntity,
    RefsVehicle,
    SharedContentList
  },
  filters: {
    getFlagEmojiByLanguage,
    getFlagEmoji
  }
})
export default class ClearanceApprovalDetail extends mixins(PartnerFallbackMixin, PermissionMixin) {
  readonly RefsTypeMap = RefTypeMap;
  readonly ClearanceApproval = ClearanceApproval;
  readonly Address = Address;
  readonly formable = ClearanceApproval;
  readonly DefaultTab = 0;
  readonly RefTypeMap = RefTypeMap;
  readonly RequestStatusEnum = RequestStatusEnum;

  @Ref("clearanceApprovalCreateRequestDialog")
  clearanceApprovalCreateRequestDialog!: ClearanceApprovalCreateRequestDialog;

  @Ref("clearanceApprovalChangeExpirationDialog")
  clearanceApprovalChangeExpirationDialog!: ClearanceApprovalChangeExpirationDialog;

  @Ref("clearanceApprovalCreateClearanceDialog")
  clearanceApprovalCreateClearanceDialog!: ClearanceApprovalCreateClearanceDialog;

  @Prop()
  value!: IClearanceApproval;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  isDeleteDialogActive = false;

  isFinishDialogActive = false;
  isFinishLoading = false;

  isDeleteLoading = false;

  isLoadingRefs = false;

  isAcceptDialog = false;

  document: ISignDocument | null = null;

  sharedContent: ISharedContent[] = [];

  onSharedContentUpdate(list: ISharedContent[]) {
    this.sharedContent.splice(0);
    this.sharedContent.push(...list);
  }

  isDocumentLoading = false;

  personSideCard: IPerson | null = null;

  companySideCard: ICompany | null = null;

  tab = 0;

  repairEstimate: IRepairEstimate | null = null;

  get alerts(): IAlert[] {
    const alerts: IAlert[] = [];

    return alerts;
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      key: "createdReadable",
      text: this.value.timestamp.createdReadable
    });

    chips.push({
      text: $t(`enums.RequestStatusEnum.${this.value.status}`),
      color: this.value.statusColor,
      key: "updatedReadable"
    });

    if (this.value.subTotal) {
      chips.push({
        text: formatCurrency(this.value.subTotal, this.value.currency),
        color: "success",
        key: "subTotal"
      });
    }

    if (this.value.status !== RequestStatusEnum.REPLIED && this.value.due) {
      chips.push({
        text: `${$t("clearanceApproval.untilWhen")} ${simpleDoubleDigitDate(this.value.due)}`,
        color: "success",
        key: "date"
      });
    }
    return chips;
  }

  get refsCategories(): BackendResourceEnum[] {
    return this.value.refsCategories;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get emailRule() {
    return [requiredRule(), emailRule()];
  }

  get phoneRule() {
    return [phoneRuleOptional()];
  }

  get subtitle() {
    return $t("createdOn", { date: simpleDoubleDigitDate(this.value.timestamp.created) });
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }
    const breadCrumbs = ClearanceApprovalGoToHelper.breadCrumbs;

    const selected = [];

    selected.push(breadCrumbs.ClearanceApprovalTable(this.value.partnerId));
    selected.push(breadCrumbs.ClearanceApprovalDetail(this.value.partnerId, this.value.id));

    return selected;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new ClearanceApprovalGoToHelper(this.$router).goToClearanceApprovalDetail({
            partnerId: this.value.partnerId,
            clearanceApprovalId: this.value.id,
            newTab: false
          })
      });
    }

    const sharedContent = this.sharedContent?.[0];
    if (sharedContent) {
      actions.push({
        text: $t("timeLine.ReportActivityBoxShareComponent.copy"),
        key: "copy",
        icon: "mdi-content-copy",
        color: "",
        exec: () => sharedContent.copyLinkToClipboard()
      });
    }

    if (!this.value.isCompleted) {
      actions.push({
        text: $t("clearanceApproval.changeExpiration"),
        key: "detail",
        icon: "mdi-calendar-edit",
        color: "",
        exec: () => this.clearanceApprovalChangeExpirationDialog.open()
      });
    }

    actions.push({
      text: $t("clearanceApproval.createClearance"),
      key: "detail",
      icon: "mdi-file-check-outline",
      color: "",
      exec: () => this.clearanceApprovalCreateClearanceDialog.open()
    });

    if (this.value.status !== RequestStatusEnum.FINISHED) {
      actions.push({
        text: $t("clearanceApproval.finish"),
        key: "finish",
        icon: "mdi-check-bold",
        exec: () => {
          this.isFinishDialogActive = true;
        }
      });
    }

    return actions;
  }

  async finishRequest() {
    this.isFinishLoading = true;
    try {
      await this.value.finish();
      this.isFinishDialogActive = false;
    } catch (error) {
      handleError(error);
    } finally {
      this.isFinishLoading = false;
    }
  }

  get bottomActions() {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new ClearanceApprovalGoToHelper(this.$router).goToClearanceApprovalDetail({
            partnerId: this.value.partnerId,
            clearanceApprovalId: this.value.id,
            newTab: false
          })
      });
    }

    if (this.can(ActionEnum.DELETE, BackendResourceEnum.CLEARANCE_APPROVAL)) {
      actions.push({
        text: $t("delete"),
        key: "title",
        icon: "mdi-trash-can",
        color: "red",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.CLEARANCE_APPROVAL
    };
  }

  get to() {
    if (this.value.seller?.email) {
      return [this.value.seller.email];
    }
    return [];
  }

  get detailTableConfig(): IMDetailTableConfig[] {
    return [
      {
        key: "title",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      },
      {
        key: "subTotal",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      },
      {
        key: "total",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      }
    ];
  }

  async mounted() {
    await this.setDocument();

    RefsMessagesModule.generateFrontendTimeLineElementsForMessagesAssociatedWithReference({
      refId: this.value.id,
      partnerId: this.value.partnerId
    });

    if (this.value.estimateId) {
      this.repairEstimate =
        RepairEstimateDataAccessLayer.get(this.value.estimateId) ??
        (await new RepairEstimate({ partnerId: this.value.partnerId, id: this.value.estimateId })
          .fetch()
          .catch((e: any) => {
            this.$log.error(e);
            return null;
          }));
    }

    this.fetchReportAndVehicle();
  }

  @Watch("value.reportId", { deep: true })
  async fetchReportAndVehicle() {
    await this.value.fetchReportAndVehicle().catch(this.$log.error);
  }

  async setDocument() {
    if (!this.value.documentId) {
      this.document = null;
      this.isDocumentLoading = false;
      return;
    }

    this.isDocumentLoading = true;
    try {
      let document = DocumentModule.maps.id.get(this.value.documentId)[0];
      if (!document) {
        document = await new SignDocument({ partnerId: this.value.partnerId, id: this.value.documentId }).fetch();
      }
      this.document = document;
    } catch (e) {
      handleError(e);
    }
    this.isDocumentLoading = false;
  }

  onDeleteItem() {
    this.isDeleteDialogActive = true;
  }

  getUserNameForId(id: string) {
    const user = PartnerUserModule.maps.id.get(id)[0];

    let name = "";
    if (user) {
      name = `${user.firstName} ${user.lastName}`;
    }

    return name;
  }

  async onDelete() {
    try {
      this.isDeleteLoading = true;

      await this.value.delete();

      this.$toast.success("👍");

      this.isDeleteDialogActive = false;

      this.$emit("deleted");
    } catch (e) {
      handleError(e);
    } finally {
      this.isDeleteLoading = false;
    }
  }

  async saveRefs() {
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: this.value.refs
      })
      .catch(handleError);
    this.isLoadingRefs = false;
  }

  openBuyerSellerSideCard(ref?: IReference) {
    if (!ref) {
      return;
    }

    if (ref.refType === ResourceEnum.PERSON) {
      const element = new Person({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.personSideCard = element;
    } else if (ref.refType === ResourceEnum.COMPANY) {
      const element = new Company({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.companySideCard = element;
    }
  }

  async resetStateBackToRequested() {
    await this.value
      .updatePartial({
        status: RequestStatusEnum.REQUESTED
      })
      .catch(handleError);
  }

  async onAssigneesUpdate(assignees: []) {
    if (!this.value) return;

    await this.value.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.value) return;

    await this.value.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.value) return;

    await this.value.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }

  goToRepairEstimate(repairEstimateId: string) {
    new RepairEstimateGoToHelper(this.$router).goToRepairEstimateDetail({
      partnerId: this.value.partnerId,
      repairEstimateId: repairEstimateId
    });
  }

  async onResponseAdded() {
    // Refresh the document when a new response is added
    await this.setDocument();
  }
}
